export const the_links = {
    support: 'https://support.abundolive.se/sv',
    support_de: 'https://support.abundolive.se/de',
    unbooking: 'https://support.abundolive.se/bokning-and-avbokning/avbokningsvillkor',
    booking_limit: 'https://support.abundolive.se/bokning-and-avbokning/hur-manga-bokningar-kan-jag-ha-samtidigt',
    booking_standby: 'https://support.abundolive.se/bokning-and-avbokning/hur-fungerar-standby',
    payment: 'https://support.abundolive.se/varfor-gar-inte-min-betalning-igenom',
    partners: 'https://support.partners.abundolive.se/',
    invite: 'https://support.abundolive.se/nyheter/ge-bort-en-gratismanad',
    privacy: '/privacy',
    terms: '/terms',
    terms_ppv: '/terms-ppv',
    how: '/how',
    careers: 'https://careers.abundolive.se',
    press: 'https://abundolive.se/press',
    facebook: 'https://www.facebook.com/abundolive',
    twitter: 'https://twitter.com/Abundolive',
    instagram: 'https://www.instagram.com/abundolive/',
    facebook_de: 'https://www.facebook.com/Abundode',
    instagram_de: 'https://www.instagram.com/abundoberlin/',
    for_companies: 'https://support.abundolive.se/en/articles/7134969-abundo-for-companies',
    reviews_google: 'https://play.google.com/store/apps/details?id=com.abundo',
    reviews_apple: 'https://apps.apple.com/app/id1464685521',
    loyalty: {
        'en': 'https://support.abundolive.se/en/articles/7878252-information-about',
        'sv': 'https://support.abundolive.se/sv/articles/7878252-information-om',
        'de': 'https://support.abundolive.se/de/articles/7878252-informationen-uber'
    }
}
